<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoFolha">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoFolha">
            <div class="formgroup">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-2">
                        <button
                            pButton
                            pRipple
                            label="Pagar"
                            icon="pi pi-plus"
                            class="p-button-outlined sm:w-9rem"
                            (click)="abrirDialogPagamento()"
                        ></button>
                    </div>
                </div>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="lancamentosFolha"
                dataKey="identificadorFolha"
                [expandedRowKeys]="expandedRows"
                [rows]="10"
                [rowHover]="true"
                [paginator]="true"
                [loading]="loading"
                [globalFilterFields]="['nomeRazaoSocial']"
                responsiveLayout="scroll"
                styleClass=" p-datatable-sm"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="flex flex-column sm:flex-row w-full">
                            <div class="p-fluid sm:w-12rem sm:mr-2">
                                <label htmlFor="filtroData">Competência</label>
                                <p-calendar
                                    view="month"
                                    dateFormat="mm/yy"
                                    [showIcon]="true"
                                    [readonlyInput]="true"
                                    [(ngModel)]="filtroCompetencia"
                                    (ngModelChange)="listar()"
                                ></p-calendar>
                            </div>
                            <div class="p-fluid sm:mr-2">
                                <label>Folha</label>
                                <p-dropdown
                                    [options]="tiposFolha"
                                    emptyMessage="Nenhum registro"
                                    optionLabel="label"
                                    optionValue="value"
                                    [(ngModel)]="tipoFolhaSelecionado"
                                    (onChange)="listar()"
                                ></p-dropdown>
                            </div>
                            <div class="mt-2 sm:mt-4 mr-2">
                                <button
                                    pButton
                                    pRipple
                                    label="Folha Empresa"
                                    pTooltip="Emitir relatório da Folha Empresa"
                                    [icon]="
                                        loadingRelatorioEmpresa
                                            ? 'pi pi-spin pi-spinner'
                                            : 'pi pi-file-pdf'
                                    "
                                    [disabled]="loadingRelatorioEmpresa || loadingRelatorioContrato"
                                    class="p-button-outlined"
                                    (click)="obterRelatorio('FOLHA_EMPRESA')"
                                ></button>
                            </div>
                            <div class="mt-2 sm:mt-4">
                                <button
                                    pButton
                                    pRipple
                                    label="Folha Contratos"
                                    pTooltip="Emitir relatório da Folha Contratos"
                                    [icon]="
                                        loadingRelatorioContrato
                                            ? 'pi pi-spin pi-spinner'
                                            : 'pi pi-file-pdf'
                                    "
                                    [disabled]="loadingRelatorioEmpresa || loadingRelatorioContrato"
                                    class="p-button-outlined"
                                    (click)="obterRelatorio('FOLHA_CONTRATOS')"
                                ></button>
                            </div>
                        </div>
                        <div class="p-fluid mt-3 sm:mt-4">
                            <div class="flex">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        #filter
                                        (input)="buscar(dt1, $event)"
                                        placeholder="Buscar"
                                        class="w-full"
                                    />
                                </span>
                                <span class="ml-2">
                                    <button
                                        pButton
                                        class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros"
                                        (click)="limpar(dt1)"
                                    ></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="body" let-folha let-expanded="expanded">
                    <tr class="bg-blue-50">
                        <td>
                            <button
                                type="button"
                                pButton
                                pRipple
                                [pRowToggler]="folha"
                                class="p-button-text p-button-rounded p-button-plain"
                                style="box-shadow: none"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                            ></button>
                        </td>
                        <td style="min-width: 12rem" class="text-lg font-semibold">
                            {{ folha.nomeRazaoSocial }}
                        </td>
                        <td class="text-lg font-semibold">
                            <span class="mr-1">Valor Líquido:</span>
                            {{ folha.valorLiquido | currency: "BRL" }}
                        </td>
                        <td style="min-width: 12rem" class="text-lg font-semibold">
                            <span class="mr-1">Valor Pago:</span>
                            {{ folha.valorPago | currency: "BRL" }}
                        </td>
                        <td style="min-width: 12rem" class="text-lg font-semibold">
                            <span class="mr-1">Valor a Receber:</span>
                            {{ folha.valorReceber | currency: "BRL" }}
                        </td>

                        <td style="text-align: center">
                            <div>
                                <button
                                    pButton
                                    pRipple
                                    pTooltip="Excluir"
                                    icon="pi pi-trash"
                                    (click)="excluirRegistroFolha(folha)"
                                    class="p-button-danger mr-2 mb-2 sm"
                                ></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-folha>
                    <tr class="surface-hover">
                        <td colspan="7">
                            <div class="px-6">
                                <p-table [value]="folha.listaPagamentos" dataKey="id">
                                    <ng-template pTemplate="body" let-item>
                                        <tr class="surface-hover">
                                            <td>
                                                <span class="font-italic">
                                                    {{ item.dataPagamento | date: "dd/MM/yyyy" }}
                                                </span>
                                            </td>
                                            <td>
                                                <span class="font-italic">
                                                    {{ item.descricaoTipoPagamento }}
                                                </span>
                                            </td>
                                            <td>
                                                <span class="font-italic">
                                                    {{ item.valor | currency: "BRL" }}
                                                </span>
                                            </td>
                                            <td style="text-align: center">
                                                <div>
                                                    <button
                                                        pButton
                                                        pRipple
                                                        pTooltip="Excluir Pagamento"
                                                        icon="pi pi-trash"
                                                        class="p-button-danger mr-2 mb-2 sm"
                                                        (click)="excluirPagamentoFolha(item)"
                                                    ></button>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr class="bg-gray-100">
                                            <td colspan="6">Nenhum registro encontrado.</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
<p-dialog
    header="Novo Pagamento"
    [(visible)]="exibirDialog"
    [modal]="true"
    [style]="{ width: '50vw' }"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
>
    <ng-template pTemplate="content">
        <div class="flex justify-content-center" *ngIf="loadingDialog">
            <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="p-fluid grid" *ngIf="!loadingDialog">
            <div class="field col-6">
                <label for="">Data</label>
                <p-calendar
                    dateFormat="dd/mm/yy"
                    [showIcon]="true"
                    [readonlyInput]="true"
                    [(ngModel)]="dataFluxoSelecionada"
                    appendTo="body"
                ></p-calendar>
            </div>
            <div class="field col-6">
                <label for="">Tipo de Pagamento</label>
                <p-dropdown
                    [options]="listaTiposPagamento"
                    emptyMessage="Nenhum registro"
                    placeholder="Selecione"
                    optionLabel="descricao"
                    [(ngModel)]="tipoPagamentoSelecionado"
                    appendTo="body"
                    (ngModelChange)="alterarTipoPagamento()"
                ></p-dropdown>
            </div>
            <div class="col-12">
                <p-table
                    #dt2
                    [value]="listaLancamentosAPagar"
                    [rows]="10"
                    [rowHover]="true"
                    [paginator]="false"
                    [loading]="loadingTableDialog"
                    responsiveLayout="scroll"
                    styleClass=" p-datatable-sm"
                    [(selection)]="listaLancamentosAPagarSelecionados"
                    selectionMode="multiple"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 4rem">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th>
                            <th>
                                <div>Nome/Razão Social</div>
                            </th>
                            <th>
                                <div>Valor a Pagar</div>
                            </th>
                            <th>Pagamento</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr>
                            <td>
                                <p-tableCheckbox [value]="item" inputId="{{ i }}"></p-tableCheckbox>
                            </td>
                            <td>
                                <label>{{ item.nomeRazaoSocial }}</label>
                            </td>
                            <td>
                                <p-inputNumber
                                    name="valorAPagar{{ i }}"
                                    ngModel
                                    #valorRegistro="ngModel"
                                    [(ngModel)]="item.valorAPagar"
                                    mode="currency"
                                    inputId="currency-brazil"
                                    currency="BRL"
                                    locale="pt-BR"
                                    [allowEmpty]="false"
                                ></p-inputNumber>
                            </td>
                            <td>
                                <p-dropdown
                                    [options]="listaTiposPagamento"
                                    emptyMessage="Nenhum registro"
                                    placeholder="Selecione"
                                    optionLabel="descricao"
                                    [(ngModel)]="item.tipoPagamento"
                                    appendTo="body"
                                ></p-dropdown>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="6">Nenhum registro encontrado.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        <div *ngIf="!loadingDialog" class="p-fluid p-formgrid grid justify-content-between">
            <div class="col-12 md:col-4 margem-zero-field">
                <button
                    *ngIf="
                        tipoPagamentoSelecionado && listaLancamentosAPagarSelecionados.length > 0;
                        else botaoFalso
                    "
                    type="button"
                    pButton
                    [icon]="
                        progressoRequisicaoSalvarDialog ? 'pi pi-spin pi-spinner' : 'pi pi-check'
                    "
                    label="Pagar"
                    class="p-button-success"
                    [disabled]="progressoRequisicaoSalvarDialog"
                    (click)="pagarLancamentos()"
                ></button>
                <ng-template #botaoFalso>
                    <button
                        type="button"
                        pButton
                        [icon]="
                            progressoRequisicaoSalvarDialog
                                ? 'pi pi-spin pi-spinner'
                                : 'pi pi-check'
                        "
                        label="Pagar"
                        class="p-button-success"
                        disabled
                    ></button>
                </ng-template>
            </div>
            <div class="col-12 md:col-4 margem-zero-field">
                <button
                    type="button"
                    pButton
                    icon="pi pi-times"
                    label="Cancelar"
                    class="p-button-danger"
                    (click)="exibirDialog = false"
                ></button>
            </div>
        </div>
    </ng-template>
</p-dialog>
